import {
  CreateBusTravelLegModal,
  CreateFlightTravelLegModal,
  CreateGroundTransportTravelLegModal,
  CreateTrainTravelLegModal,
} from "Bands/containers";
import { TravelLegType } from "Bands/types";
import { FC, useCallback, useState } from "react";
import { copy } from "shared/assets";
import { Title } from "shared/components";
import { Spacer } from "shared/layout";
import { AddTravelLegButtons } from ".";

const travelLegCopy = copy.travelBlock.travelLeg;

interface Props {
  blockId: string;
}

export const AddTravelLeg: FC<Props> = ({ blockId }) => {
  const [createModal, setCreateModal] = useState<TravelLegType | null>(null);

  const renderCreateModal = useCallback(() => {
    switch (createModal) {
      case TravelLegType.flight: {
        return (
          <CreateFlightTravelLegModal blockId={blockId} handleClose={() => setCreateModal(null)} />
        );
      }
      case TravelLegType.bus: {
        return (
          <CreateBusTravelLegModal blockId={blockId} handleClose={() => setCreateModal(null)} />
        );
      }
      case TravelLegType.train: {
        return (
          <CreateTrainTravelLegModal blockId={blockId} handleClose={() => setCreateModal(null)} />
        );
      }
      case TravelLegType.groundTransport: {
        return (
          <CreateGroundTransportTravelLegModal
            blockId={blockId}
            handleClose={() => setCreateModal(null)}
          />
        );
      }
    }
  }, [blockId, createModal]);

  return (
    <Spacer size="m">
      <Title asComponent="h3" size="s">
        {travelLegCopy.title}
      </Title>
      <div>
        <AddTravelLegButtons
          handleAddFlight={() => setCreateModal(TravelLegType.flight)}
          handleAddBus={() => setCreateModal(TravelLegType.bus)}
          handleAddTrain={() => setCreateModal(TravelLegType.train)}
          handleAddGroundTransport={() => setCreateModal(TravelLegType.groundTransport)}
        />
      </div>
      {renderCreateModal()}
    </Spacer>
  );
};
